import { ReactNode } from 'react'
import StateIcon from 'components/StateIcon'
import { StateDialogContent, StateDialogStyle, StateDialogText } from './styles'
import { Modal } from 'antd'
import { CloseIcon } from 'components/Icons'

interface IProps {
  children: ReactNode,
  state: 'success' | 'fail',
  visible: boolean,
  onClose?: () => void
}

const StateDialog = (props: IProps) => {
  const { state, visible, onClose, children } = props

  return (
    <Modal
      className="confirm-modal"
      closeIcon={<CloseIcon />}
      visible={visible}
      footer={null}
      onCancel={() => onClose && onClose()}
      centered
      closable
      maskClosable
    >
      <StateDialogContent>
        <StateDialogStyle />

        <StateIcon type={state} />

        <StateDialogText>
          {children}
        </StateDialogText>
      </StateDialogContent>
    </Modal>
  )
}

export default StateDialog
